import { cn } from '@/lib/utils';
import { getBrandLogo } from '@/lib/branding';

/**
 * 品牌 Logo：上传商标后显示图片，否则显示默认「昌」字方块。
 * PC 侧边栏 / 移动抽屉 / 启动屏共用。
 * size 单位 px；variant 控制默认方块样式（侧边栏=emerald 圆角方块，其他=同款）。
 */
export function BrandLogo({
  size = 44,
  rounded = 'rounded-xl',
  className,
}: {
  size?: number;
  rounded?: string;
  className?: string;
}) {
  const logo = getBrandLogo();
  if (logo) {
    return (
      <img
        src={logo}
        alt="品牌商标"
        width={size}
        height={size}
        className={cn('object-contain', rounded, className)}
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <div
      className={cn(
        'flex items-center justify-center bg-emerald-600 text-white font-bold shadow-lg shadow-emerald-900/30',
        rounded,
        className
      )}
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.42),
      }}
    >
      昌
    </div>
  );
}
